import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useEffect, useState } from 'react';
import { useStripe, useElements,Elements, CardElement } from '@stripe/react-stripe-js';
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import { validateService} from "../service/validation.service";
import { apiService} from "../service/api.service";

import Loader from "../common/Loader";
import swal from 'sweetalert';
const BankDetails = () => {



  const [loader,setLoader]=useState(false)
  const [updateDetail,setupdateDetail]=useState(true)
  const [updatechecked,setupdatechecked]=useState(true)
  const [updateShow,setupdateShow]=useState(false)
  const [stripeCustomerId,setstripeCustomerId]=useState(localStorage.getItem("stripeCustomerId"))
  const [stripeBankId,setstripeBankId]=useState(localStorage.getItem("stripeBankId"))
  
  const [bankFieldsErrs, setbankFieldsErrs] = useState({
    account_number: "",
     routing_number: "",
    account_holder_name: "",
    bank_name: "",
    terms_and_conditions:""
  
});
const stripe = useStripe();
const [bankFields, setbankFields] = useState({
  account_number: "",
   routing_number: "",
  account_holder_name: "",
  bank_name: "STRIPE TEST BANK",
  terms_and_conditions:false,
  account_holder_type:"individual"
});
useEffect(() => { 
   console.log("====stripeCustomerId====",stripeCustomerId)
   console.log("====stripeBankId====",stripeBankId)
 if(stripeCustomerId!="null" && stripeBankId!=="null") {
     getBank()
     
    }else{
      if(stripeCustomerId=="null" || stripeBankId=="null"){
      setupdateDetail(false)
      setupdatechecked(false)
      setupdateShow(true)
      addBank("NA")
      console.log("====NA====",stripeCustomerId)
      }
    }
  
  // if(stripeCustomerId=="null" || stripeCustomerId==null){
  //   console.log("====stripeCustomerId===niii=",stripeCustomerId)
  //   addBank("NA")
  // }else{
  //   getBank()
  // }
  
   },[stripeCustomerId])
const handleSubmit = async (event) => {
  
  event.preventDefault();
  let valid = validateService.bankValidate(setbankFieldsErrs,bankFields)
  // bankValidate
  if (!stripe) {
    return;
  }
if(valid){
  setLoader(true)
  const result = await stripe.createToken('bank_account', {
    bank_account: {
      country: 'US',
      currency: 'usd',
      account_holder_name: bankFields.account_holder_name,
      account_holder_type: 'individual',
      routing_number: bankFields.routing_number,
      account_number: bankFields.account_number,
    
      metadata: {
        bank_name: bankFields.bank_name
      }
      
    },
    
  },
  {
    stripeAccount: localStorage.getItem("stripeCustomerId")
  });

  if (result.error) {
    setLoader(false)
    swal("Error",result.error.message,"error")
    console.error(result.error.message);
  } else {
    addBank(result.token.id)
    console.log(result.token);
 }
}
};
const handleKeyDownnumber = (event) => {
  console.log("=====event====", event.which);
  if (event.which === 32) {
    event.preventDefault(); // Prevent space key action
  }
  if (event.key === "Enter" || event.which === 13) {
    event.preventDefault(); // Prevent the default behavior (page refresh)
    // Handle your logic here
  }
};
const addBank = (banktoken) => {
  apiService.addBank(banktoken).then((res) => {
    setLoader(false)
    // console.log("=======bank data====>", res.data)
    setstripeCustomerId(res.data.data.user.stripeCustomerId)
    localStorage.setItem("profile_status",res.data.data.user.status)
    localStorage.setItem("stripeCustomerId",res.data.data.user.stripeCustomerId)
    localStorage.setItem("stripeBankId",res.data.data.user.stripeBankId)
    setstripeBankId(res.data.data.user.stripeBankId)
    if(banktoken!=="NA"){
      setupdateDetail(true)
      setupdatechecked(true)
            swal({ icon: 'success', text: "Bank Added Successfully! ", button: "OK" }).then(() => {
               window.location.reload()
              });
      // swal("Success","Bank Added Successfully!","success")
    
    }
    getBank()
  }).catch((err) => { 
    setLoader(false)

    console.log("=======err==get==>", err.response)
    console.log("=======err====>", err)

  });


}
const getBank = () => {
  setLoader(true)
  let bankDetail={
    account_numberShow: "",
     routing_number: "",
    account_holder_name: "",
    bank_name: ""
  }
  apiService.getBank().then((res) => {
    setLoader(false)
     console.log("======Get=bank data====>", JSON.parse(res.data.data.account))
     setupdateShow(false)
    let bankDatas =  JSON.parse(res.data.data.account)
    bankDetail.account_numberShow="xxxxxxxx"+bankDatas.last4
    bankDetail.routing_number=bankDatas.routing_number
    bankDetail.account_holder_name=bankDatas.account_holder_name
    bankDetail.bank_name=bankDatas.bank_name
    console.log("====bankDetail==>>.",bankDetail)
    setbankFields(bankDetail)
      // setbankList(res.data.data)

  }).catch((err) => { 
    setLoader(false)
 
    // setupdateShow(true)
  });


}



const varifyAccount = ()=>{
  apiService.stripLink().then((res) => {
    console.log(res.data.data.url)
    window.open(res.data.data.url, '_blank');
    setLoader(false)
  }).catch((err) => { 
    setLoader(false)
 
    // setupdateShow(true)
  });
}
  return (
    <>
        {loader && <Loader/>}
      <div className="height-footer contact-us-section">
        <Container>
          <div className="">
            <div className='product-header-area'>
              <div>
                <h2 className='subheading-under'>Bank Details</h2>
                <p>View and manage your bank account details here.</p>
              </div>
              {/* {updateShow&&
              <div className='under-heading'>
                <Button className='green-btn' onClick={()=>{updateDetail?setupdateDetail(false):setupdateDetail(true)}}>Update Details</Button>
              </div>} */}
            </div>
            <Row className='justify-content-center'>
              <Col md={6}>
                
                <div className='stock-shadow'>
                  <Form className="login-body mt-3">
                    <Form.Group className="mb-3 position-relative">
                      <Form.Label>Bank Name </Form.Label>
                      <Form.Control disabled={updateDetail}  maxLength={50} type="text" placeholder="Enter Full Name"  value={bankFields?.bank_name} onChange={(e) => setbankFields((prevObj) => {  return { ...prevObj, bank_name: e.target.value}; })}/>
                      <span className="errors">{bankFieldsErrs.bank_name}</span>
                    </Form.Group>
                    <Form.Group className="mb-3 position-relative">
                      <Form.Label>Account Type </Form.Label>
                      <select disabled={updateDetail} className='form-select' value={bankFields?.account_holder_type} onChange={(e) => setbankFields((prevObj) => {  return { ...prevObj, account_holder_type: e.target.value}; })}>
                        <option value="individual">Saving</option>
                        <option value="company">Checking</option>
                      </select>
                     <span className="errors">{bankFieldsErrs.account_number}</span>
                    </Form.Group>
                    <Form.Group className="mb-3 position-relative">
                      <Form.Label>Account Number </Form.Label>
                      <Form.Control    onWheel={() => document.activeElement.blur()} onKeyDown={handleKeyDownnumber} type={updateDetail?"text":"number"}  disabled={updateDetail}
                      placeholder="Enter Account Number" value={bankFields?.account_numberShow
                      } onChange={(e) => setbankFields((prevObj) => {  return { ...prevObj, account_number: e.target.value,account_numberShow:e.target.value}; })}/>
                      <span className="errors">{bankFieldsErrs.account_number}</span>
                    </Form.Group>
                    <Form.Group className="mb-3 position-relative">
                      <Form.Label>Account Holder Name </Form.Label>
                      <Form.Control type="text"  maxLength={30} disabled={updateDetail} placeholder="Enter Account Holder Name"  value={bankFields?.account_holder_name} onChange={(e) => setbankFields((prevObj) => {  return { ...prevObj, account_holder_name: e.target.value}; })}/>
                      <span className="errors">{bankFieldsErrs.account_holder_name}</span>
                    </Form.Group>
                    <Form.Group className="mb-3 position-relative">
                      <Form.Label>Routing Number </Form.Label>
                      <Form.Control type="text" disabled={updateDetail} placeholder="Enter Routing Number"  value={bankFields?.routing_number}  onChange={(e) => setbankFields((prevObj) => {  return { ...prevObj, routing_number: e.target.value}; })}/>
                       <span className="errors">{bankFieldsErrs.routing_number}</span>
                    </Form.Group>
                    <Form.Group className="mb-4" controlId="formBasicCheckbox">
                      
                    <Form.Check type="checkbox"   checked={updatechecked} disabled={updateDetail} label={
                      <>
                        <span>By registering your account, you agree to our Services Agreement and the <a className="terms-condition" href="https://stripe.com/connect-account/legal/full" target="_blank">Stripe Connected Account Agreement</a>.</span>
                      </>
                    }
                      onChange={(e) => {
                        setbankFields((prevObj) => {
                          return {
                            ...prevObj,
                            terms_and_conditions: e.target.checked
                          };
                        });
                        setupdatechecked(e.target.checked)
                      }}
                    />
                     <span className="errors">{bankFieldsErrs.terms_and_conditions}</span>
                    </Form.Group>
                    {updateDetail && localStorage.getItem("profile_status")==="Stripe_Details_Pending"? <Button className="green-btn" onClick={varifyAccount}>Verify </Button>:<>{!updateDetail?<Button className="green-btn" onClick={handleSubmit}>Save </Button>:null }</>
}
                  </Form>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
export default BankDetails;
